/* unplugin-vue-components disabled */import { render } from "./KilaKilaDivider.vue?vue&type=template&id=04111851&scoped=true"
import script from "./KilaKilaDivider.vue?vue&type=script&lang=js"
export * from "./KilaKilaDivider.vue?vue&type=script&lang=js"

import "./KilaKilaDivider.vue?vue&type=style&index=0&id=04111851&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04111851"]])

export default __exports__